(() => {
  'use strict';
  const overlay = document.getElementById('mm-thanks');
  if (!overlay) return;
  const panel = overlay.querySelector('.mm-thanks-dialog');
  const close = overlay.querySelector('.mm-thanks-close');
  let oldOverflow = '';
  function dismiss() {
    if (overlay.hidden) return;
    overlay.hidden = true;
    document.body.style.overflow = oldOverflow;
    document.body.classList.remove('mm-thanks-complete');
    const orderArea = document.querySelector('.mpl-order,.apa-order');
    if (orderArea) orderArea.scrollIntoView({block:'start',behavior:'smooth'});
  }
  overlay.querySelectorAll('[data-mm-thanks-close]').forEach(button => button.addEventListener('click',dismiss));
  overlay.addEventListener('keydown',event => {
    if (event.key === 'Escape') { event.preventDefault(); dismiss(); }
    if (event.key === 'Tab') {
      const buttons = Array.from(overlay.querySelectorAll('button:not([disabled])'));
      const first = buttons[0], last = buttons[buttons.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  window.MMShowThankYou = () => {
    oldOverflow = document.body.style.overflow;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('mm-thanks-complete');
    panel.scrollTop = 0;
    close.focus();
  };
  if (window.MMThankYouEditorPreview) window.MMShowThankYou();
  if (window.MMThankYouPending) { window.MMThankYouPending = false; window.MMShowThankYou(); }
})();
